<template>
    <PortalAbonadosSga v-if="teatro.sga" />
    <PortalAbonadosAvet v-else />
</template>

<script>

    import PortalAbonadosAvet from '@/components/frontend/lfp/PortalAbonadosAvet.vue';
    import PortalAbonadosSga from '@/components/frontend/lfp/PortalAbonadoSga.vue';

    export default {
        components: {
            
            PortalAbonadosAvet,
            PortalAbonadosSga
        },
        created() {
            if (!(this.footer.lfp === 1 && this.teatro.sga === 0)) {
                this.$router.push('/');
            }
        },
        head: {
            title: function() {
                return {
                    inner: 'Mi abono',
                    complement: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title
                }
            },
            meta: function() {
                return [
                    {name: 'application-name', content: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title + ' - Venta Oficial de entradas'},
                    {name: 'description', content: this.teatro.meta_description ? this.teatro.meta_description : 'Compra tus entradas en el punto oficial de venta en tan sólo 2 minutos. Venta oficial de entradas. Mejor precio garantizado. Compralaentrada', id: 'desc'}
                ]                
            },
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            footer() {
                return this.$store.getters.getFooter;
            }
        }
    }
</script>